import type { RootState } from '../store'

export const selectFolders = (state: RootState) => state.workspace.folders
export const selectFoldersStatus = (state: RootState) => state.workspace.foldersStatus

export const selectDocuments = (state: RootState) => state.workspace.documents
export const selectDocumentsStatus = (state: RootState) => state.workspace.documentsStatus

export const selectDocumentsByFolder = (folderId: string | null) => (state: RootState) => {
  const docs = folderId === null
    ? state.workspace.documents
    : state.workspace.documents.filter((d) => d.folderId === folderId)

  return [...docs].sort((a, b) =>
    (a.title || 'Untitled').localeCompare(b.title || 'Untitled', undefined, {
      sensitivity: 'base',
    })
  )
}

export const selectOpenDocument = (id: string) => (state: RootState) =>
  state.workspace.openDocuments[id]

export const selectFiles = (state: RootState) => state.workspace.files
export const selectFilesStatus = (state: RootState) => state.workspace.filesStatus

export const selectFilesByFolder = (folderId: string | null) => (state: RootState) =>
  state.workspace.files.filter((f) =>
    folderId === null ? !f.folderId : f.folderId === folderId
  )

export const selectFilesByDocument = (documentId: string) => (state: RootState) =>
  state.workspace.files.filter((f) => f.documentId === documentId)

export const selectLinkedDocuments = (taskId: string) => (state: RootState) =>
  state.workspace.documents.filter((d) => d.linkedTaskIds.includes(taskId))

export const selectLinkedFiles = (taskId: string) => (state: RootState) =>
  state.workspace.files.filter((f) => f.linkedTaskIds.includes(taskId))

export const selectLinkedFolders = (taskId: string) => (state: RootState) =>
  state.workspace.folders.filter((f) => f.linkedTaskIds.includes(taskId))

export const selectLinkedTasks = (linkedTaskIds: string[]) => (state: RootState) =>
  state.tasks.items.filter((task) => linkedTaskIds.includes(task.id))
